import { CLAIM_TARIFF_STATUS, type ClaimTariffStatusValue } from './tariff';

export interface TariffCalculationRules {
  readonly billed: boolean;
  readonly paid: boolean;
  readonly outstanding: boolean;
  readonly adjustment: boolean;
}

export const TARIFF_CALCULATION_RULES: Record<
  ClaimTariffStatusValue,
  TariffCalculationRules
> = {
  [CLAIM_TARIFF_STATUS.INCOMPLETE]: {
    billed: false,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.READY]: {
    billed: false,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.REVERTED]: {
    billed: false,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.SUBMITTED]: {
    billed: true,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.RESUBMITTED]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.PENDING]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.QUERIED]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.PAYOR_INVOICED]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.REJECTED]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.UNDERPAID]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.UNINSURED]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.PENDING_WRITE_OFF]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.PAID]: {
    billed: true,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.OVERPAID]: {
    billed: true,
    paid: true,
    outstanding: true,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.WRITTEN_OFF]: {
    billed: true,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.UNCLAIMABLE]: {
    billed: true,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.HISTORICAL]: {
    billed: false,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.CANCELLED]: {
    billed: false,
    paid: false,
    outstanding: false,
    adjustment: false,
  },
  [CLAIM_TARIFF_STATUS.UNMATCHED]: {
    billed: false,
    paid: true,
    outstanding: false,
    adjustment: false,
  },
} as const;

export type TariffCalculationEligibility = TariffCalculationRules;

export const getTariffCalculationEligibility = (
  status: ClaimTariffStatusValue,
  hasBeenSubmitted: boolean
): TariffCalculationEligibility => {
  const rules = TARIFF_CALCULATION_RULES[status];
  const isPreviouslySubmittedReady =
    status === CLAIM_TARIFF_STATUS.READY && hasBeenSubmitted;

  return {
    ...rules,
    billed: rules.billed || isPreviouslySubmittedReady,
    outstanding: rules.outstanding || isPreviouslySubmittedReady,
  };
};
